import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Label } from 'recharts';

const API_URL = 'http://localhost:4000/api/metrics';

export default function Dashboard() {
  const [metrics, setMetrics] = useState([]);

  useEffect(() => {
    async function fetchMetrics() {
      try {
        const { data } = await axios.get(API_URL);
        setMetrics(data);
      } catch (error) {
        console.error('Error fetching metrics:', error);
      }
    }
    fetchMetrics();
  }, []);

  return (
    <Box sx={{ p: 4, borderRadius: 2, boxShadow: 3, bgcolor: 'background.paper' }}>
      <Typography variant="h4" gutterBottom>
        Métricas de Usuario
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Este gráfico muestra las interacciones de los usuarios con la aplicación.
      </Typography>
      <LineChart width={800} height={400} data={metrics}>
        <CartesianGrid stroke="#ccc" />
        <XAxis dataKey="timestamp" tickFormatter={(tick) => new Date(tick).toLocaleString('es-ES')}>
          <Label value="Fecha y Hora" offset={-5} position="insideBottom" />
        </XAxis>
        <YAxis>
          <Label value="Acciones Realizadas" angle={-90} position="insideLeft" />
        </YAxis>
        <Tooltip
          formatter={(value, name, props) => [
            props.payload.description || value,
            'Detalles',
          ]}
        />
        <Legend />
        <Line type="monotone" dataKey="action" stroke="#8884d8" name="Acción Realizada" />
      </LineChart>
    </Box>
  );
}
